'use strict';

frontendApp.factory('ResourceText', ['$resource', 'ConfigService', 'TokenService', function ($resource, ConfigService, TokenService) {

  var _service = {};

  _service.plainSrc = function (projectId, collectionId, resourceId) {
    return ConfigService.getServerBaseUrl() +
      "/project/" + projectId +
      "/collection/" + collectionId +
      "/resource/" + resourceId +
      "/text" +
      "?client_id=" + ConfigService.getClientId() +
      "&access_token=" + TokenService.GetAccessToken();
  };

  _service.richSrc = function (projectId, collectionId, resourceId) {
    return ConfigService.getServerBaseUrl() +
      "/project/" + projectId +
      "/collection/" + collectionId +
      "/resource/" + resourceId +
      "/richText" +
      "?client_id=" + ConfigService.getClientId() +
      "&access_token=" + TokenService.GetAccessToken();
  };

  _service.pdfSrc = function (projectId, collectionId, resourceId) {
    return ConfigService.getServerBaseUrl() +
      "/project/" + projectId +
      "/collection/" + collectionId +
      "/resource/" + resourceId +
      "/pdf" +
      "?client_id=" + ConfigService.getClientId() +
      "&access_token=" + TokenService.GetAccessToken();
  };

  _service.playerSrc = function (projectId, collectionId, resourceId) {
    return ConfigService.getServerBaseUrl() +
      "/project/" + projectId +
      "/collection/" + collectionId +
      "/resource/" + resourceId +
      "/playable" +
      "?client_id=" + ConfigService.getClientId() +
      "&access_token=" + TokenService.GetAccessToken();
  };

  return _service;

}]);
